import React, { useCallback, useMemo } from 'react'

import { PAYMENT_METHODS } from '@constants/paymentMethods'
import { PAYMENT_PROVIDERS } from '@constants/paymentProviders'
import { PaymentMethodStatus } from '@enums'
import { ConfirmPaymentParams, SubmitEventPayload } from '@hooks/useBookingFlow'
import PaymentLabel from '@pages/Checkout/Payment/Label'

export const useMercadoPago = () => {
  const submitForm = useCallback((): SubmitEventPayload => {
    return {
      paymentMethodData: {
        type: 'mp',
        return_url: typeof window !== 'undefined' ? window.location.href : '',
      },
    }
  }, [])

  const confirmPayment = useCallback((response: ConfirmPaymentParams) => {
    const actionData = response.details?.action as { redirect?: string }
    if (actionData?.redirect) {
      window.location.href = actionData.redirect
    }
  }, [])

  return useMemo(
    () => ({
      status: PaymentMethodStatus.Ready,
      getOption: () => ({
        value: PAYMENT_METHODS.MERCADO_PAGO,
        label: <PaymentLabel type={PAYMENT_METHODS.MERCADO_PAGO} />,
      }),
      provider: PAYMENT_PROVIDERS.MERCADOPAGO,
      on: { submitForm, confirmPayment },
    }),
    [submitForm, confirmPayment],
  )
}
